import React from 'react'
import { imgURL } from '@/utils/countryVersion'
import _logo from '@/assets/imgs/logo.svg'

const logo = imgURL('./imgs/logo.png') || _logo

const Fallback = () => {
  return (
    <div style={{ position: 'relative', height: '100vh', width: '100vw' }}>
      <img src={logo} alt="pageloading" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: '50vw' }} />
    </div>
  )
}

Fallback.displayName = 'Fallback'

export default Fallback
